// import * as React from "react";
import { TextAlignProperty } from "csstype";
import { ETabType } from "utils/enum/orderListEnum";

// 订单列表 列表字段模型
class OrderModel {
  // 订单状态
  public orderStatus: string;
  // 确认函
  public isMail: string;
  // 团号
  public groupNumber: string;
  // 客人账号
  public account: string;
  // 联系人姓名
  public contactName: string;
  // 下单日期
  public submitDate: string;
  // 审核日期
  public verifyTime: string;
  // 出发日期
  public goTime: string;
  // SKU名称
  public skuName: string;
  // 数/成/儿/婴
  // 销售数量
  public saleNum: string;
  // 成人数量
  public adultNum: string;
  // 儿童数量
  public childrenNum: string;
  // 婴儿数量
  public babyNum: string;
  // 交易状态
  public orderPayStatus: string;
  // 客服
  public headId: string;
  // 供应商
  public supplierCode: string;
  // 订单来源
  public fromSource: string;
  // 处理建议（满员订单需要展示）
  public fullRemark: string;
  // 退订失败（退订失败订单展示）
  public unsubscribeRemark: string;
  // 异常原因 （异常订单展示）
  public abnormalRemark: string;
  // 订单交易状态汉字
  public orderPayStatusStr: string;
  // 订单标签
  public tags: string;
  // 详情链接
  public detailUrl: string;
  // 电话|国内电话
  public phone: string;
  // 邮箱
  public email: string;
  // 国外电话
  public foreignPhone: string;
  // 商城账号
  public mallAccount: string;
  // 淘宝账号
  public taoAccount: string;

  // 映射为表格列的字段标题并且提供默认的排序顺序和基础样式
  static mapToColumn(field, sort) {
    const commSett = (field, label, sort) => {
      return {
        dataIndex: field,
        width: 80,
        key: field,
        title: label,
        align: "center" as TextAlignProperty,
        sort,
        render: null
      };
    };
    switch (field) {
      // case "id":
      //   return {
      //     ...commSett(field, "id", sort || 0),
      //     width: 120
      //   };
      case "orderStatus":
        return {
          ...commSett(field, "订单状态", sort || 1),
          width: 120
        };
      case "fullRemark":
        return {
          ...commSett(field, "处理建议", sort || 2),
          width: 120
        };
      case "unsubscribeRemark":
        return {
          ...commSett(field, "退订失败", sort || 3),
          width: 120
        };
      case "abnormalRemark":
        return {
          ...commSett(field, "异常原因", sort || 4),
          width: 120
        };
      case "isMail":
        return {
          ...commSett(field, "确认函", sort || 5)
          // width: 80
        };
      case "groupNumber":
        return {
          ...commSett(field, "团号", sort || 7)
          // flex: "0 0 180px"
        };
      case "account":
        return {
          ...commSett(field, "客人账号", sort || 6),
          width: 160
        };
      case "contactName":
        return {
          ...commSett(field, "联系人姓名", sort || 8),
          width: 120
        };
      case "submitDate":
        return {
          ...commSett(field, "下单日期", sort || 9),
          width: 100
        };
      case "verifyTime":
        return {
          ...commSett(field, "审核日期", sort || 10),
          width: 100
        };
      case "goTime":
        return {
          ...commSett(field, "出发日期", sort || 11),
          width: 100
        };
      case "skuName":
        return {
          ...commSett(field, "SKU名称", sort || 12)
        };
      case "saleNum":
        return {
          ...commSett(field, "数/成/儿/婴", sort || 13),
          width: 110
        };
      case "headid":
        return {
          ...commSett(field, "客服", sort || 14),
          width: 80
        };
      case "supplierCode":
        return {
          ...commSett(field, "供应商", sort || 15),
          width: 90
        };
      case "orderPayStatus":
        return {
          ...commSett(field, "交易状态", sort || 16),
          width: 110
        };
      case "fromSource":
        return {
          ...commSett(field, "订单来源", sort || 17),
          width: 110
        };
      default:
        // return {
        //   ...commSett(field, "id", sort || 17),
        //   width: 120
        // };
        return null;
    }
  }

  static getColumn(eTabType = ETabType.All) {
    const cValue = Number(eTabType);
    if (cValue === NaN) {
      eTabType = ETabType.All;
    } else {
      eTabType = cValue;
    }

    // 默认需要显示的字段
    const defaultColumns = [
      "adultNum",
      "babyNum",
      "childrenNum",
      "contactName",
      "fromSource",
      "goTime",
      "groupNumber",
      "headid",
      "id",
      "isMail",
      "account",
      "mallAccount",
      "orderPayStatus",
      "orderStatus",
      "saleNum",
      "skuName",
      "sku",
      "submitDate",
      "supplierCode",
      "taoAccount",
      "verifyTime"
    ];

    switch (eTabType) {
      // 满员
      case ETabType.Full:
        return [...defaultColumns, "fullRemark"];
      // 退订失败
      case ETabType.UnsubscribeFailure:
        return [...defaultColumns, "unsubscribeRemark"];
      // 异常
      case ETabType.Abnormal:
        return [...defaultColumns, "abnormalRemark"];
      // 全部
      case ETabType.All:
      // 其它
      default:
        return defaultColumns;
    }
    // "fullRemark",
    // "unsubscribeRemark",
    // "abnormalRemark"
  }
  static getShortColumn(eTabType = ETabType.All) {
    const cValue = Number(eTabType);
    if (cValue === NaN) {
      eTabType = ETabType.All;
    } else {
      eTabType = cValue;
    }

    // 默认需要显示的字段
    const defaultColumns = [
      "account",
      "taoAccount",
      "groupNumber",
      "headid",
      "submitDate",
      "goTime",
      "skuName",
      "saleNum"
    ];

    switch (eTabType) {
      // 满员
      case ETabType.Full:
        return [...defaultColumns, "fullRemark"];
      // 退订失败
      case ETabType.UnsubscribeFailure:
        return [...defaultColumns, "unsubscribeRemark"];
      // 异常
      case ETabType.Abnormal:
        return [...defaultColumns, "abnormalRemark"];
      // 全部
      case ETabType.All:
      // 其它
      default:
        return defaultColumns;
    }
    // "fullRemark",
    // "unsubscribeRemark",
    // "abnormalRemark"
  }
}

export default OrderModel;
